var env = process.env.REACT_APP_ENV || "development";
module.exports = require("./" + env + ".js");